import * as api from '@/http'

export const ActionStoreIC = async ({ dispatch }, payload) => {
  const sended_ics = await api.http
    .post('dash/coordinator/ic', payload)
    .then((response) => response.data)
  dispatch('ActionAlterSendedIC', sended_ics)
}

export const ActionSetSendedIC = async ({ dispatch }) => {
  const sended_ics = await api.http
    .get('dash/coordinator/ic/sended')
    .then((response) => response.data)
  dispatch('ActionAlterSendedIC', sended_ics)
}

export const ActionSetReceivedIC = async ({ dispatch }) => {
  const received_ics = await api.http
    .get('dash/coordinator/ic/received')
    .then((response) => response.data)
  dispatch('ActionAlterReceivedIC', received_ics)
}

export const ActionSignIC = async ({ dispatch }, icId) => {
  const received_ics = await api.http
    .post(`dash/coordinator/ic/sign/${icId}`)
    .then((response) => response.data)
  dispatch('ActionAlterReceivedIC', received_ics)
}

export const ActionVisualizeIC = async ({ dispatch }, icId) => {
  const received_ics = await api.http
    .put(`dash/coordinator/ic/visualize/${icId}`)
    .then((response) => response.data)
  dispatch('ActionAlterReceivedIC', received_ics)
}

export const ActionAlterSendedIC = async ({ commit }, payload) => {
  payload.sort(function (a, b) {
    var c = new Date(a.created_at)
    var d = new Date(b.created_at)
    return d - c
  })
  commit('SET_sended_ics', payload)
}
export const ActionAlterReceivedIC = async ({ commit }, payload) => {
  payload.sort(function (a, b) {
    var c = new Date(a.created_at)
    var d = new Date(b.created_at)
    return d - c
  })
  commit('SET_received_ics', payload)
}
